// ── Currency formatting ──────────────────────────────────────────────────────

/** ₹1,23,456 — zero decimal places */
export const fmt = (n: number) =>
  '₹' + (n ?? 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });

/** ₹1,23,456.78 — two decimal places */
export const fmt2 = (n: number) =>
  '₹' + (n ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Raw two-decimal string, no currency symbol */
export const fmtNum = (n: number) => (n ?? 0).toFixed(2);

// ── Date helpers ─────────────────────────────────────────────────────────────

/** Returns today's date as YYYY-MM-DD */
export const today = () => new Date().toISOString().slice(0, 10);

// ── ID helpers ───────────────────────────────────────────────────────────────

/** Generates a random short ID for transient client-side use */
export const uid = () => Math.random().toString(36).slice(2);

// ── GST ──────────────────────────────────────────────────────────────────────

export const GST_RATES = [0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28];

// ── India states ─────────────────────────────────────────────────────────────

export const INDIA_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Delhi', 'Jammu and Kashmir', 'Ladakh',
];

// ── TDS sections ─────────────────────────────────────────────────────────────

export const TDS_SECTIONS = ['194A', '194C', '194H', '194I', '194J', '194Q', '194R', '195'];

// ── Payment modes ─────────────────────────────────────────────────────────────

export const PAYMENT_MODE_LABELS: Record<string, string> = {
  cash: 'Cash', upi: 'UPI', bank_transfer: 'Bank Transfer', cheque: 'Cheque', other: 'Other',
};

// ── Invoice doc type labels ───────────────────────────────────────────────────

export const DOC_TYPE_LABELS: Record<string, string> = {
  tax_invoice: 'Tax Invoice',
  bill_of_supply: 'BOS',
  quotation: 'Quotation',
  credit_note: 'CN',
  debit_note: 'DN',
  lorry_receipt: 'LR',
};

// ── Invoice status badge classes ─────────────────────────────────────────────

export const STATUS_BADGE: Record<string, string> = {
  paid: 'badge-paid',
  unpaid: 'badge-unpaid',
  overdue: 'badge-overdue',
  draft: 'badge-draft',
};

// ── Currency list ────────────────────────────────────────────────────────────

export const CURRENCIES = ['INR', 'USD', 'EUR', 'GBP', 'AED', 'SGD'];
